require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-reggio-emilia.json") })
        }
      }, "path---learning-reggio-emilia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-reggio-emilia!./.cache/json/learning-reggio-emilia.json
// module id = 1245
// module chunks = 231608221292675